import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { RfpProOfferConfirmPage } from '@/pages/rfp/professional/offer/RfpProOfferConfirm/RfpProOfferConfirmPage';
import { RFP_TYPE_PUBLIC_OFFERING_VALUE, RFP_TYPE_DIRECT_OFFER_VALUE, } from '@/utils/constants/rfp/rfpType';
import { getIsPublic } from '@/utils/resources/rfp/rfpProOfferSave';
import { professionalRfpOfferPath } from '@/utils/router/links';
/**
 * コンサルタント：案件提案提出確認ページのロジック部分
 */
export const RfpProOfferConfirm = (props) => {
    const { changeStepValue, formValues, lockId, rfp } = props;
    const offerValues = formValues.offer;
    const isPublic = getIsPublic(rfp.rfp_type, offerValues);
    const initialValues = useMemo(() => isPublic
        ? Object.assign(Object.assign({}, formValues), { offer: offerValues, rfpType: RFP_TYPE_PUBLIC_OFFERING_VALUE }) : Object.assign(Object.assign({}, formValues), { offer: offerValues, rfpType: RFP_TYPE_DIRECT_OFFER_VALUE }), [isPublic, formValues, offerValues]);
    /**
     * 入力された値が正しいかどうか（支払い方法）
     */
    const getIsValidPaymentValues = useCallback((values) => values.options !== null, []);
    /**
     * 入力された値が正しいかどうか（案件メンバー）
     */
    const getIsValidMemberValues = useCallback((values) => values.every((value) => value.role !== null && value.involvement !== null), []);
    /**
     * 入力された値が正しいかどうか（提案内容 RFI/業務委託）
     */
    const getIsValidDirectValues = useCallback((values) => getIsValidPaymentValues(values.payment) &&
        getIsValidMemberValues(values.rfp_offer_members), [getIsValidPaymentValues, getIsValidMemberValues]);
    /**
     * 入力された値が正しいかどうか（公募）
     */
    const getIsValidPublicValues = useCallback((values) => values.offer.period !== null &&
        values.offer.price !== null &&
        getIsValidPaymentValues(values.payment) &&
        getIsValidMemberValues(values.rfp_offer_members), [getIsValidPaymentValues, getIsValidMemberValues]);
    const getIsValid = useCallback((values) => initialValues.rfpType === RFP_TYPE_PUBLIC_OFFERING_VALUE
        ? getIsValidPublicValues(initialValues)
        : getIsValidDirectValues(initialValues), [initialValues, getIsValidPublicValues, getIsValidDirectValues]);
    const isValid = getIsValid(initialValues);
    // 入力値が正しくない場合（バリーデーションが通っているため true になる想定）
    if (!isValid) {
        return (_jsx(CustomRedirect, { message: '入力内容が正しくありません。入力内容を見直してください。', state: { lockId }, to: professionalRfpOfferPath(rfp.id) }));
    }
    return (_jsx(RfpProOfferConfirmPage, { changeStepValue: changeStepValue, initialValues: initialValues, lockId: lockId, rfp: rfp }));
};
